import {
    allFetch,
    ResultObj
} from "../Domain";

/**
* @description 查詢員工班表
* @param allotment_time_start 配發日期起
* @param allotment_time_end 配發日期迄
*/

export interface ScheduleXEmployeeSearchParams {
    date_start: string,
    date_end: string,
    user_ids: string[],
    company_id: string,
    general_manager_id: string,
    department_id: string,
    position_id: string,
    class_id: string,
    group_id: string,
    office_id: string,
}
export interface ScheduleXEmployeeSearchResItem {
    sXe_id: number;
    sc_id: string;
    sc_name: string;
    sc_code: string;
    salary_type: string;
    date: string;
    leave_minutes: number;
    overtime_work_minutes: number;
    rest_time_json: string;
    salary_type_name: string;
    user_id: string;
    vacation_type: string;
    vacation_type_name: string;
    work_minutes: number;
    work_time_json: string;
}
export const ScheduleXEmployeeSearch =
    async (obj: ScheduleXEmployeeSearchParams = {
        date_start: '',
        date_end: '',
        user_ids: [],
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: ''
    }): Promise<ResultObj<ScheduleXEmployeeSearchResItem[]>> => await allFetch('ScheduleClass/ScheduleXEmployeeSearch', obj);


/**
* @description 修改員工班表
* @param ScheduleXEmployees 
*/
export interface ScheduleXEmployeeUpdateParams {
    List: ScheduleXEmployees[]
}
export interface dataArray {
    success: boolean;
    message: string;
    data: dataArray[] | string;
    page: number;
    count: number;
    dt2: null;
}
export interface ScheduleXEmployeeUpdateResItem {
    data: {
        CSCP: dataArray;
        CSCG: dataArray;
    } | null,
    dt2: null;
    message: string;
    success: boolean;
    page: number;
    count: number;

}
export const ScheduleXEmployeeUpdate =
    async (obj: ScheduleXEmployeeUpdateParams = {
        List: []
    }): Promise<ResultObj<ScheduleXEmployeeUpdateResItem | null>> => await allFetch('ScheduleClass/ScheduleXEmployeeUpdate', obj);


/**
* @description ScheduleXEmployees
* @param user_id 帳號編號
* @param ScheduleXEmployeeDetail 
*/
export interface ScheduleXEmployees {
    user_id: string,
    List: ScheduleXEmployeeDetail[]
}
/**
* @description ScheduleXEmployeeDetail
* @param sc_id 班表流水號
* @param date 日期 
* @param vacation_type 假日種類 
*/
export interface ScheduleXEmployeeDetail {
    sc_id: string,
    date: string,
    vacation_type: string
}



/**
* @description 檢查員工班表
* @param date_start 檢查日期起
* @param date_end 檢查日期迄
* @param List 員工和他的班表 們
*/

export interface CheckScheduleClassParams {
    date_start: string,
    date_end: string,
    List: ScheduleXEmployees[]
}
export interface CheckScheduleClassResItem {
}
export const CheckScheduleClass =
    async (obj: CheckScheduleClassParams = {
        date_start: '',
        date_end: '',
        List: []
    }): Promise<ResultObj<CheckScheduleClassResItem[]>> => await allFetch('ScheduleClass/CheckScheduleClass', obj);


/**
* @description 班表查詢
* @param sc_id 班表流水號
* @param sc_name 班表名稱
* @param sc_code 班表代號
* @param sc_type 班表種類(正常工時班表、延長工時班表)
* @param sc_label 班表標籤
* @param visible 是否可見
* @param page 頁碼
* @param num_per_page 一頁幾筆
*/

export interface ScheduleClassSearchParams {
    sc_id: string,
    sc_name: string,
    sc_code: string,
    sc_type: string,
    sc_label: string,
    visible: string,
    page: number,
    num_per_page: number
}
export interface ScheduleClassSearchResItem {
    basic_work_minutes: number;
    note: string;
    overtime_work_minutes: number;
    rest_time_json: string;
    salary_type: string;
    salary_type_name: string;
    sc_code: string;
    sc_id: string;
    sc_label: string;
    sc_label_name: string;
    sc_name: string;
    sc_type: string;
    visible: string;
    work_minutes: number;
    work_time_json: string;
}
export const ScheduleClassSearch =
    async (obj: ScheduleClassSearchParams = {
        sc_id: '',
        sc_name: '',
        sc_code: '',
        sc_type: '',
        sc_label: '',
        visible: '',
        page: 1,
        num_per_page: 10
    }): Promise<ResultObj<ScheduleClassSearchResItem[]>> => await allFetch('ScheduleClass/ScheduleClassSearch', obj);


/**
* @description 新增班表 (參數)
* @param sc_name 班表名稱
* @param sc_code 班表代號
* @param sc_type 班表種類(正常工時班表、延長工時班表)
* @param sc_label 班表標籤
* @param salary_type 薪水種類
* @param basic_worktime 基本工時
* @param note 備註
* @param WorkTime 工作時段物件
* @param RestTimeList 休息時段物件們
*/

export interface ScheduleClassCreateParams {
    sc_name: string,
    sc_code: string,
    sc_type: string,
    sc_label: string,
    salary_type: string,
    basic_worktime: string,
    note: string
    WorkTime: WorkTime
    RestTimeList: RestTimeList[]
}

export interface WorkTime {
    work_time_start: string,
    work_time_end: string,
    work_across_night: string
}
export interface RestTimeList {
    rest_time_start: string,
    rest_time_end: string,
    rest_across_night: string
}

/** @description 新增班表 */
export const ScheduleClassCreate =
    async (obj: ScheduleClassCreateParams = {
        sc_name: '',
        sc_code: '',
        sc_type: '',
        sc_label: '',
        salary_type: '',
        basic_worktime: '',
        note: '',
        WorkTime: {
            work_time_start: '',
            work_time_end: '',
            work_across_night: ''
        },
        RestTimeList: []
    }): Promise<ResultObj> => await allFetch('ScheduleClass/ScheduleClassCreate', obj);

/**
* @description 修改班表 (參數)
* @param sc_id 班表流水號
* @param sc_name 班表名稱
* @param sc_code 班表代號
* @param sc_type 班表種類(正常工時班表、延長工時班表)
* @param sc_label 班表標籤
* @param salary_type 薪水種類
* @param basic_worktime 基本工時
* @param visible 是否可見
*/

export interface ScheduleClassUpdateParams {
    sc_id: string,
    sc_name: string,
    sc_code: string,
    sc_type: string,
    sc_label: string,
    salary_type: string,
    basic_worktime: string,
    note: string
    WorkTime: WorkTime
    visible: string,
}

/** @description 修改班表 */
export const ScheduleClassUpdate =
    async (obj: ScheduleClassUpdateParams = {
        sc_id: '',
        sc_name: '',
        sc_code: '',
        sc_type: '',
        sc_label: '',
        salary_type: '',
        basic_worktime: '',
        note: '',
        WorkTime: {
            work_time_start: '',
            work_time_end: '',
            work_across_night: ''
        },
        visible: '',
    }): Promise<ResultObj> => await allFetch('ScheduleClass/ScheduleClassUpdate', obj);


/**
* @description 修改班表休息時段們 (參數)
* @param sc_id 班表流水號
* @param RestTimeList 休息時段物件們
*/

export interface ScheduleClassUpdateRestTimeParams {
    sc_id: string,
    RestTimeList: RestTimeList[]
}

/** @description 修改班表休息時段們 */
export const ScheduleClassUpdateRestTime =
    async (obj: ScheduleClassUpdateRestTimeParams = {
        sc_id: '',
        RestTimeList: [],
    }): Promise<ResultObj> => await allFetch('ScheduleClass/ScheduleClassUpdateRestTime', obj);
